module.exports = __webpack_public_path__ + "img/confetti.1f66153a.svg";